import React from "react";
import { candidateStatusOptions } from "../../../../../hooks/useRecruitmentCandidates";

const statusColorMap = candidateStatusOptions.reduce((acc, status) => {
  acc[status.value] = status.color;
  return acc;
}, {});

const readableLabelMap = candidateStatusOptions.reduce((acc, status) => {
  acc[status.value] = status.label;
  return acc;
}, {});

const CandidateStatusBadge = ({ status }) => {
  if (!status) {
    return <span className="badge bg-secondary">N/A</span>;
  }

  const normalizedStatus = status.toUpperCase();
  const colorClass = statusColorMap[normalizedStatus] || "secondary";
  const label = readableLabelMap[normalizedStatus] || normalizedStatus;

  return <span className={`badge bg-${colorClass}`}>{label}</span>;
};

export default CandidateStatusBadge;
